import { render } from "./editor.vue?vue&type=template&id=c3622916&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"

import "./editor.vue?vue&type=style&index=0&id=c3622916&lang=scss&scoped=true"

import exportComponent from "/Users/helgeohltpng/Developer/js/triton/hoTriton/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3622916"]])

export default __exports__